var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg1Tablet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 770,
    height: 696,
    viewBox: "0 0 770 696",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_94335)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_442_94335)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 438.554,
    cy: 640.358,
    rx: 438.554,
    ry: 640.358,
    transform: "matrix(0.697674 0.716415 -0.683113 0.730313 1195.88 -320.07)",
    fill: "url(#paint0_linear_442_94335)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_442_94335)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 438.554,
    cy: 640.358,
    rx: 438.554,
    ry: 640.358,
    transform: "matrix(0.697674 0.716415 -0.683113 0.730313 1392.44 -862)",
    fill: "url(#paint1_linear_442_94335)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_442_94335",
    x: 158.539,
    y: -473.68,
    width: 1811.73,
    height: 1870.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 186,
    result: "effect1_foregroundBlur_442_94335"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_442_94335",
    x: 355.102,
    y: -1015.61,
    width: 1811.73,
    height: 1870.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 186,
    result: "effect1_foregroundBlur_442_94335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_442_94335",
    x1: 438.554,
    y1: 0,
    x2: 438.554,
    y2: 1280.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22D695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D695",
    stopOpacity: 0.59
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_442_94335",
    x1: 438.554,
    y1: 0,
    x2: 438.554,
    y2: 1280.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434BEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434BEE",
    stopOpacity: 0.59
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_94335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    height: 696,
    fill: "white",
    transform: "translate(-143)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1Tablet);
export default __webpack_public_path__ + "static/media/bg1-tablet.c7459219387102bcccef01ad131b01e7.svg";
export { ForwardRef as ReactComponent };